/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_ColInputs */

const en_admin_users_credits_col = /** @type {(inputs: Admin_Users_Credits_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const zh_admin_users_credits_col = /** @type {(inputs: Admin_Users_Credits_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Admin_Users_Credits_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_col = /** @type {((inputs?: Admin_Users_Credits_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_credits_col(inputs)
	return zh_admin_users_credits_col(inputs)
});
export { admin_users_credits_col as "admin.users.credits_col" }